

    
var se_classic = new Vue({
    el:'#se_classic',
    data:function(){
        return{
            flag:0,
            mouseFlag:0,
            Tflag:0,
            info:[
                {title:'Black Gold',icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Color_01.png?v=1687250718',
                img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/01-Black_Gold.png?v=1687250708'},
                {title:'Black Silver',icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Color_02.png?v=1687250718',
                img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/02-Black_Silver.png?v=1687250708'},
                {title:'Purple Blue',icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Color_03.png?v=1687250718',
                img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/03-Purple_Blue.png?v=1687250708'},
                {title:'Black Pink',icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Color_04.png?v=1687250718',
                img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/04-Black_Pink.png?v=1687250708'},
                {title:'Black Blue',icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Color_05.png?v=1687250718',
                img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/05-Black_Blue.png?v=1687250708'},
                {title:'Silver',icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Color_06.png?v=1687250718',
                img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/06-Silver.png?v=1687250707'},
                {title:'Gunmetal',icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Color_07.png?v=1687250718',
                img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/07-Gunmetal.png?v=1687250707'},
                {title:'Black',icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Color_08.png?v=1687250718',
                img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/08-Black.png?v=1687250707'},
                {title:'Pure Orange',icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Color_09.png?v=1687250717',
                img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/09-Pure_Orange.png?v=1687250708'},
                {title:'Pure Blue',icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Color_10.png?v=1687250717',
                img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/10-Pure_Blue.png?v=1687250708'},
                {title:'Pure Purple',icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Color_11.png?v=1687250717',
                img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/11-Pure_Purple.png?v=1687250708'},
                {title:'Pure Green',icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Color_12.png?v=1687250717',
                img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/12-Pure_Green.png?v=1687250708'},
                {title:'Pure Gunmetal',icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Color_13.png?v=1687250717',
                img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/13-Pure_Gunmetal.png?v=1687250708'},
                {title:'Pure Black',icon:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Color_14.png?v=1687250717',
                img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/14-Pure_Black.png?v=1687250706'}
            ],
            box6Flag:0,
            box6Info:[
                {title:'V2 Cartridge',img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/V2_9a8a6d3e-396c-444c-9396-79534b2b034c.png?v=1687659638'},
                {title:'Top-Fill Cartridge',img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Top-Fill_Cartridge.png?v=1687659638'}
            ]
        }
    },
    methods:{
        watch:function(index){
            this.flag = index;
            this.Tflag = index;
        },
        //模块六切换事件
        Box6Qie:function(index){
            this.box6Flag = index;
        },
        mouse:function(index){
            this.Tflag = -1;
            this.mouseFlag = index;
        },
        out:function(){
            this.mouseFlag = -1;
            this.Tflag = this.flag;
        }
    }
})


let controller1 = new ScrollMagic.Controller();

//secton2 
var box2_title=document.getElementsByClassName('box2_title');
var box2_subtitle=document.getElementsByClassName('box2_subtitle');
var box2_items=document.getElementsByClassName('box2_items');
let scene2 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.section2', 
        triggerHook: "onenter",
        duration:0,
})
scene2.on("progress", function (event) {
    box2_title[0].classList.add("showup");
    box2_title[1].classList.add("showup");
    box2_subtitle[0].classList.add("showup");
    box2_items[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box2_title[0].classList.remove("showup");
        box2_title[1].classList.remove("showup");
        box2_subtitle[0].classList.remove("showup");
        box2_items[0].classList.remove("showup");
    }
})

//secton4 
var box4_content=document.getElementsByClassName('box4_content');
let scene4 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.section4', 
        triggerHook: "onenter",
        duration:0,
})
scene4.on("progress", function (event) {
    box4_content[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box4_content[0].classList.remove("showup");
    }
})

//secton5 
var box5_content=document.getElementsByClassName('box5_content');
let scene5 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.section5', 
        triggerHook: "onenter",
        duration:0,
})
scene5.on("progress", function (event) {
    box5_content[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box5_content[0].classList.remove("showup");
    }
})

//secton7 
var box7_content=document.getElementsByClassName('box7_content');
let scene7 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.section7', 
        triggerHook: "onenter",
        duration:0,
})
scene7.on("progress", function (event) {
    box7_content[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box7_content[0].classList.remove("showup");
    }
})

//secton8
var box8_title=document.getElementsByClassName('box8_title');
let scene8 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.section8', 
        triggerHook: "onenter",
        duration:0,
})
scene8.on("progress", function (event) {
    box8_title[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box8_title[0].classList.remove("showup");
    }
})

//secton9
var box9_title=document.getElementsByClassName('box9_title');
let scene9 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.section9', 
        triggerHook: "onenter",
        duration:0,
})
scene9.on("progress", function (event) {
    box9_title[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box9_title[0].classList.remove("showup");
    }
})

controller1.addScene([scene2,scene4,scene5,scene7,scene8,scene9]); 

$('.pnr_buy').click(function(){
    window.open('https://store.oxva.com/products/oxva-xlim-se-kit-classic-edition');
})

$('.pnr_spec').click(function(){
    var element = document.querySelector(".section8");
    element.scrollIntoView({block: "end"});
})

var box9_swiper = new Swiper('.box9_swiper', {
    // autoplay: true,
    navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
    disabledClass: 'my-button-disabled',
    },
})

var box9_swiper = new Swiper('.Mbox9_swiper', {
    // autoplay: true,
    navigation: {
    nextEl: '.Mswiper-button-next',
    prevEl: '.Mswiper-button-prev',
    disabledClass: 'my-button-disabled',
    },
})
